import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../filters';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from "luxon";

export default {
  name: 'supportServSchedule',
  components: {
    DataGridComp: require('../../customcontrols/datagrid.vue').default,
    datetime: Datetime,
    DateTime,
  },
  props: {
    applicationId: {
      type: String,
      required: true
    },
    appKey: {
      type: String,
      required: true
    },
  },
  data: function () {
    return {
      options: { pageSize: 10, filterText: '', page: 1 },
      scheduleItems: [],
      keyColumn: 'id',
      totalRow: 0,
      addingNewItem: false,
      scheduleCols: [],
      schedule: {
        id: 0,
        sourceId: this.applicationId,
        sourceSubId: 0,
        supportServiceId: 0,
        supportServiceTypeId: 0,
        periodDate: new Date().toISOString(),
        periodBegin: new Date().toISOString(),
        periodEnd: new Date().toISOString(),
        periodDuration: '0',
        periodTypeId: 0,
        comment: '',
        usageTypeId: 0,
        wholeDay: false,
        activity: []
      },
      isNewItem: true,
      showConfirmDelete: false,
      deleteMessage: '',
      showTypesGrid: false,
      selectType: {
        typeId: -1,
        stationId: -1,
        teamId: -1
      },
      filterdSupportServices: [],
      supportServicesCols: [],
      supportServicesKeyColumn: 'id',
      wholeDay: false,
      perEnd: '',
      perBegining: '',
    }
  },
  created() {
    this.fillScheduleCols();
    this.getSupportServiceSchedules();
    this.fillSupportServicesCols();
    this.filterdSupportServices = this.$store.state.supportServicesScheduleLookups.supportServices;
    //console.log("ServicesScheduleLookups",this.filterdSupportServices);
  },
  computed: {
    typeId: function () {
      return this.selectType.typeId;
    },
    stationId: function () {
      return this.selectType.stationId;
    },
    teamId: function () {
      return this.selectType.teamId;
    },
  },
  watch: {
    perBegining: function (val) {
      this.schedule.periodBegin = this.convertDate(val);
      this.calculateDuration();
    },
    perEnd: function (val) {
      this.schedule.periodEnd = this.convertDate(val);
      this.calculateDuration();
    },
    wholeDay: function (val) {
      if (val) {
        this.perBegining = "1999-01-01T00:00:00";
        this.perEnd = "1999-01-01T00:00:00";
        this.schedule.periodBegin = "1999-01-01T00:00:00";
        this.schedule.periodEnd = "1999-01-01T00:00:00";
      } else {
        this.perBegining = "";
        this.perEnd = "";
        this.schedule.periodBegin = "";
        this.schedule.periodEnd = "";
      }
      this.schedule.periodDuration = '0';
      this.schedule.wholeDay = val;
    },
    typeId: function (value) {
      this.filterSupportServices();
    },
    stationId: function (value) {
      this.filterSupportServices();
    },
    teamId: function (value) {
      this.filterSupportServices();
    },
  },
  methods: {
    convertDate(val) {

      let valDate = new Date(val);
      let perDate = new Date(this.schedule.periodDate);

      //construct final date in sql datetime format from period date base and hours from val
      let date = perDate.getFullYear() + '-' +
        ('00' + (perDate.getMonth() + 1)).slice(-2) + '-' +
        ('00' + perDate.getDate()).slice(-2) + 'T' +
        ('00' + valDate.getHours()).slice(-2) + ':' +
        ('00' + valDate.getMinutes()).slice(-2) + ':' +
        '00';

      return date;
    },
    calculateDuration() {
      //extract time build a new date
      let e = new Date(this.schedule.periodEnd);
      let st = new Date(this.schedule.periodBegin);

      let now = new Date();
      let end = now.setHours(e.getHours(), e.getMinutes());
      let start= now.setHours(st.getHours(), st.getMinutes());

      //find difference and c0nvert it to hrs
      this.schedule.periodDuration = String(Math.floor((end - start) / 1000 / 60 ));

      //error trap
      if ((this.schedule.periodDuration < 0 || isNaN(this.schedule.periodDuration)) && !this.wholeDay) {
        this.schedule.periodDuration = '0';
        //this.$alertMsg(`${this.$t('messages.startEndTimeError')}`, 3);
      }
      //console.log("dur", this.schedule.periodDuration);

      if (this.schedule.wholeDay)
        this.schedule.periodTypeId = 2;
      else
        this.schedule.periodTypeId = 1;

      this.$forceUpdate();
    },
    getSupportServiceSchedules() {
      axios.post('/Schedule/GetSupportServiceSchedules', {
        sourceId: Number(this.applicationId),
        sourceSubId: 0,//Number(this.appKey),
        options: this.options
      })
        .then(response => {
          if (response.status == 200) {
            response.data.items.forEach(item => {
              item.begin = moment(item.periodBegin).format('HH:mm:ss');
              item.end = moment(item.periodEnd).format('HH:mm:ss');
              item.periodDuration = Math.floor((Date.parse(item.periodEnd) - Date.parse(item.periodBegin)) / 1000 / 60);
            });

            this.scheduleItems = response.data.items;
            this.totalRow = response.data.itemsCount;

            this.addingNewItem = false;
          } else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(error => {
          error.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${error.response.status}`) :
            this.$alertMsg(error.data.data.text);
        })
    },
    pageChange(pInfo) {
      if (pInfo.pageNumber == this.options.page && pInfo.pageSize == this.options.pageSize)
        return;

      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;

      this.getSupportServiceSchedules();
    },
    selectionChanged(info) {

    },
    onRowDblClick(info) {
      if (!info.data || !info.data.id)
        return;
     
      this.isNewItem = false;
      this.addingNewItem = true;


      if (!info.data || !info.data.id)
        return;

      this.schedule = {
        id: info.data.id,
        sourceId: info.data.sourceId,
        sourceSubId: info.data.sourceSubId,
        supportServiceTypeId: info.data.supportServiceTypeId,
        supportServiceType: info.data.supportServiceType,
        supportServiceId: info.data.supportServiceId,
        supportService: info.data.supportService,
        periodTypeId: info.data.periodTypeId,
        periodDate: info.data.periodDate,
        periodBegin: info.data.periodBegin,
        periodEnd: info.data.periodEnd,
        comment: info.data.comment,
        usageTypeId: info.data.usageTypeId,
        periodDuration: info.data.periodDuration,
        wholeDay: info.data.periodTypeId == 2 ? true : false,
        item: info.data.item
      };

      this.perBegining = this.schedule.periodBegin;
      this.perEnd = this.schedule.periodEnd;
      this.isNewItem = false;
      this.addingNewItem = true;

      if (this.schedule.periodTypeId == 2)
        this.schedule.wholeDay = true;
      else
        this.schedule.wholeDay = false;

      this.wholeDay = this.schedule.wholeDay;
    },
    fillScheduleCols() {
      this.scheduleCols = [];

      this.scheduleCols.push({ dataField: 'supportService', name: 'supportService', caption: this.$t('schedule.item') });
      this.scheduleCols.push({ dataField: 'usageType', name: 'usageType', caption: this.$t('schedule.usageType') });
      this.scheduleCols.push({ dataField: 'periodDate', name: 'periodDate', caption: this.$t('schedule.usageDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.scheduleCols.push({ dataField: 'periodType', name: 'periodType', caption: this.$t('schedule.periodType') });
      this.scheduleCols.push({ dataField: 'begin', name: 'begin', caption: this.$t('schedule.begin'), dataType: 'dastringte' });
      this.scheduleCols.push({ dataField: 'end', name: 'end', caption: this.$t('schedule.end'), dataType: 'string'});
      this.scheduleCols.push({ dataField: 'periodDuration', name: 'periodDuration', caption: this.$t('schedule.duration') });
      this.scheduleCols.push({ dataField: 'comment', name: 'comment', caption: this.$t('schedule.comment') });
    },
    addNewItem() {
      this.schedule = {
        id: 0,
        sourceId: this.applicationId,
        sourceSubId: 0,
        supportServiceId: 0,
        supportServiceTypeId: 0,
        supportServiceType: '',
        item: '',
        periodDate: new Date().toISOString(),
        periodBegin: '',
        periodEnd: '',
        periodDuration: '0',
        periodTypeId: this.$store.state.supportServicesScheduleLookups.periodTypes.length == 0 ? 0 : this.$store.state.supportServicesScheduleLookups.periodTypes[0].value,
        comment: '',
        usageTypeId: this.$store.state.supportServicesScheduleLookups.usageTypes.length == 0 ? 0 : this.$store.state.supportServicesScheduleLookups.usageTypes[0].value,
        wholeDay: false
      };
      this.isNewItem = true;
      this.addingNewItem = true;
      this.wholeDay = false;
      this.perBegining = '';
      this.perEnd = ''
    },
    saveItem() {
      //console.log(this.schedule);
      //error checks
      if (this.schedule.supportServiceId < 0 || this.schedule.supportServiceTypeId < 0) {
        this.$alertMsg(this.$t('messages.itemNotSelected'), 3);
        return;
      }

      if (!this.wholeDay) {
        if (this.schedule.periodEnd != null && this.schedule.periodEnd != '' && this.schedule.periodBegin != null && this.schedule.periodBegin != '') {
          this.calculateDuration();
        }
        else {
          this.$alertMsg(this.$t('messages.completeStarEndTime'), 3);
          return;
        }
      }

      if (this.schedule.periodDuration < 0 && !this.wholeDay) {
        this.$alertMsg(this.$t('messages.wrongStarEndTime'), 3);
        return;
      }

      if (!this.schedule.usageTypeId || this.schedule.usageTypeId < 0) {
        this.$alertMsg(this.$t('schedule.usageTypeError'), 3);
        return;
      }

      axios.post('/Schedule/InsertOrUpdateSupportServiceSchedule', this.schedule)
        .then(response => {
          this.getSupportServiceSchedules();
          this.$alertMsg(this.$t('messages.supServiceSchedSaved'), 2);
        })
        .catch(error => {
          this.$alertMsg(error);
          console.log(error);
        })
    },
    deleteSchedule() {
      axios.post('/Schedule/DeleteSupportServiceSchedule', { Value: this.schedule.id })
        .then(response => {
          this.getSupportServiceSchedules();
        })
        .catch(error => {
          this.$alertMsg(error);
          console.log(error);
        })
    },
    supportServicesOnRowDblClick(info) {
      //console.log("supp serv",info);

      this.schedule.supportServiceTypeId = info.data.supportServiceTypeId;
      this.schedule.supportServiceType = info.data.supportServiceType;

      this.schedule.supportServiceId = info.data.id;
      this.schedule.supportService = info.data.name;
      this.showTypesGrid = false;
    },
    fillSupportServicesCols() {
      this.supportServicesCols = [];

      this.supportServicesCols.push({ dataField: 'supportServiceType', name: 'supportServiceType', caption: this.$t('schedule.type') });
      this.supportServicesCols.push({ dataField: 'name', name: 'name', caption: this.$t('schedule.item') });
      this.supportServicesCols.push({ dataField: 'station', name: 'station', caption: this.$t('schedule.station') });
      this.supportServicesCols.push({ dataField: 'team', name: 'team', caption: this.$t('schedule.team') });
    },
    filterSupportServices() {

      this.filterdSupportServices = this.$store.state.supportServicesScheduleLookups.supportServices;

      if (this.selectType.typeId != -1)
        this.filterdSupportServices = this.filterdSupportServices.filter(a => a.supportServiceTypeId == this.selectType.typeId);

      if (this.selectType.stationId != -1) 
        this.filterdSupportServices = this.filterdSupportServices.filter(a => a.stationId == this.selectType.stationId);

      if (this.selectType.teamId != -1)
        this.filterdSupportServices = this.filterdSupportServices.filter(a => a.teamId == this.selectType.teamId);
    }
  }
}

